import { NextSeo } from 'next-seo';
import Head from 'next/head';

//screens
import { AI } from '/screens/';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

//vendor
import { GoogleEnhancedConversion } from '../vendor';

export default function AIPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="freight AI, autonomous transportation execution, AI-native TMS, freight automation, dock scheduling AI, freight experts, "
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        canonical="https://loadsmart.com/ai/"
        title="Loadsmart AI | Autonomous Transportation Execution"
        openGraph={{
          url: 'https://loadsmart.com/ai/',
        }}
      />
      <JsonLd data={Organization} />
      <AI />

      {process.env.NOINDEX_FLAG ? '' : <GoogleEnhancedConversion />}
    </>
  );
}
